import { Filters } from "../enums/filters";

export class SDKDataGridFilter {
    public operation?: Filters[];
    public value?: any;
}